<rx-search
  [placeholder]="payload.placeholder || 'Search...'"
  [(ngModel)]="keyword"
  (ngModelChange)="onKeywordChange($event)"
  (keydown.enter)="onEnterKeyPressed()"
></rx-search>

@if (payload.loading$ ? (payload.loading$ | async) : false) {
  <div class="list-body">
    <div class="list-loading">
      <rx-progress-spinner class="small-blue-loader"></rx-progress-spinner>
    </div>
  </div>
} @else {
  <div class="list-body">
    @if (filteredItems$ | async; as items) {
      @if (items.length) {
        <cdk-virtual-scroll-viewport itemSize="48" class="list-viewport">
          <rx-list-item
            *cdkVirtualFor="let item of items"
            [title]="item?.name"
            [icon]="payload?.icon || 'icon-folder'"
            [ngClass]="{ active: payload.selectedItem === item }"
            (click)="selectItem(item)"
          ></rx-list-item>
        </cdk-virtual-scroll-viewport>
      } @else {
        <div class="list-empty">
          <rx-no-data>No results found. Please refine your search criteria.</rx-no-data>
        </div>
      }
    }
  </div>
}
